<div class="app-modal">
  <!-- <header class="edit-header">
    <h1>記録を選択</h1>
  </header> -->
  <div class="container">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <section>
        <h2>利用者を選択</h2>
        <app-dai-search-select [placeholder]="'利用者を選択する'" [multiple]="false" (usersChange)="changeUser($event)" [selectedId]="[userForm.value]" [arrowType]="1">
        </app-dai-search-select>
      </section>
      <section>
        <h2>タイトルを選択</h2>
        <ul *ngIf="titleSetList" class="panel-list">
          <li *ngFor="let titleSet of titleSetList; index as i">
            <app-record-select-item [titleSet]="titleSet" [form]="getForm(i)"></app-record-select-item>
          </li>
        </ul>
      </section>
      <app-edit-footer [navigationFinally]="historyBackWard" excuteText="選択"
        [disabled]="form.invalid || !isValid"></app-edit-footer>
    </form>
  </div>
</div>
